import {
  Backend,
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import { EnterprisesCollection } from './enterprises.types';

export function enterprisesBackend(): Backend<EnterprisesCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'users/0.1/enterprises/',
      params: {
        enterprises: ids,
        names: getQueryParamValue(query, 'name'),
        internal_names: getQueryParamValue(query, 'internal_name'),
        seo_urls: getQueryParamValue(query, 'seo_url'),
        // We want to include all test enterprises for now.
        // This is because we don't have any specific logic around test enterprises as of yet.
        // Once we have a better picture of what that should be, then we may update this.
        ignore_test: false,
      },
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
